export const getRouteParam = (paramName: string) => {
  const route = useRoute()
  if (Array.isArray(route.params[paramName])) {
    return String(route.params[paramName][0])
  }
  return route.params[paramName] ? String(route.params[paramName]) : ''
}
export const getRouteQuery = (queryName: string) => {
  const route = useRoute()
  return route.query[queryName] ? String(route.query[queryName]) : ''
}

export const isSamePage = (guardPath: string, currentPath: string) => {
  const regex = /^(.+)\/[^/]+$/

  const base1 = guardPath.match(regex)?.[1]
  const base2 = currentPath.match(regex)?.[1]

  return base1 === base2
}
